import Hls from 'hls.js';

// Signed stream URLs fail with 403 (bad/missing signature) or 410 (expired).
export const SIGNATURE_EXPIRY_HTTP_CODES: readonly number[] = [403, 410];

export type StreamErrorData = {
  fatal?: boolean;
  type?: string;
  response?: { code?: number };
};

export function isSignatureExpiredError(
  data: StreamErrorData | null | undefined
): boolean {
  if (!data || !data.fatal) return false;
  if (data.type !== Hls.ErrorTypes.NETWORK_ERROR) return false;
  const code = data.response?.code;
  return code !== undefined && SIGNATURE_EXPIRY_HTTP_CODES.includes(code);
}
